import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ERTEmergencyResponseService } from "../../services/emergency-response/emergency-response.service";
import { ERTUser } from "../../interfaces/ert-user/ert-user";
import { ERTUserService } from "../../services/ert-user/ert-user.service";
import { FormBuilder } from "@angular/forms";
import { LoggedUserService } from "../../services/common/logged-user.service";

@Component({
  selector: "ert-emergency-response-details-component",
  templateUrl: "./ert-emergency-response-details.component.html",
})
export class ERTEmergencyResponseDetailsComponent implements OnInit {
  links: any[] = [];
  ertUsers: ERTUser[] = [];
  validationMessages: string[] = [];

  constructor(
    private http: HttpClient,
    private router: Router,
    private ertUserService: ERTUserService,
    public ertEmergencyResponseService: ERTEmergencyResponseService,
    private fb: FormBuilder,
    private loggedUserService: LoggedUserService
  ) {}

  ngOnInit() {
    this.loggedUserService.getLoggedUserData().subscribe((user) => {
      const facilityId = Number(user.facilityId) || 1;

      this.ertUserService.getAllERTUsers(facilityId).subscribe((data) => {
        this.ertUsers = data;
        this.ertUsers = data.filter((user) =>
          user.picklistValues.some((picklist) => picklist.value === "PP")
        );
        this.ertUsers.sort((a, b) => a.lastName.localeCompare(b.lastName));
      });
    });
  }

  goToAdditionalInfo() {
    this.validationMessages =
      this.ertEmergencyResponseService.validateNewEmergencyResponseStep1(
        this.ertEmergencyResponseService.addEmergencyResponseForm
      );
    if (this.validationMessages.length === 0) {
      this.router.navigateByUrl(
        "/ert-emergency-response/emergency-additional-info"
      );
    }
  }
}
